import { LOCALE_CONFIG } from './index';

type SupportedLocale = keyof typeof LOCALE_CONFIG;

const getConfig = (locale: string) =>
  LOCALE_CONFIG[locale as SupportedLocale] ?? LOCALE_CONFIG['es-MX'];

export function formatCurrencyLocale(value: number | null | undefined, locale: string): string {
  if (value === null || value === undefined) return '$0';
  const cfg = getConfig(locale);
  return new Intl.NumberFormat(cfg.locale, {
    style: 'currency',
    currency: cfg.currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value);
}

export function formatNumberLocale(value: number, locale: string): string {
  const cfg = getConfig(locale);
  return new Intl.NumberFormat(cfg.locale, cfg.numberFormat).format(value);
}

export function formatPercentLocale(value: number, locale: string): string {
  const cfg = getConfig(locale);
  return new Intl.NumberFormat(cfg.locale, {
    minimumFractionDigits: 1,
    maximumFractionDigits: 2,
  }).format(value) + '%';
}

export function formatDateLocale(value: string | Date | null | undefined, locale: string): string {
  if (!value) return '—';
  try {
    const cfg = getConfig(locale);
    return new Intl.DateTimeFormat(cfg.locale, {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    }).format(new Date(value));
  } catch {
    return String(value);
  }
}
